import React from 'react';
import PropTypes from 'prop-types';

function IconToggleOn({ color = `#FF9800`, className }) {
  return (
    <svg width="40" height="24" viewBox="0 0 40 24" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.00012207" y="0.5" width="40" height="24" rx="12" fill={color} />
      <circle cx="28.0001" cy="12.5" r="10" fill="#121212"/>
    </svg>
  )
}

IconToggleOn.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string
}

export default IconToggleOn;
